/**
 * The public site, for the sign-in screen's way back to it.
 *
 * Its own origin — `app-athena.com`, where the product is `my.app-athena.com`
 * — baked in at build time like `VITE_API_URL`, because it is a fact about the
 * deployment rather than about the person. Unset, a production build points
 * at the production site and a development one at the marketing dev server,
 * so no environment ships a link to localhost.
 */
import type { Language } from './language.js'

const FALLBACK = import.meta.env.DEV ? 'http://localhost:5175' : 'https://app-athena.com'

function origin(): string {
  const configured = (import.meta.env.VITE_MARKETING_URL as string | undefined)?.trim()
  try {
    const url = new URL(configured || FALLBACK)
    return ['http:', 'https:'].includes(url.protocol) ? url.origin : new URL(FALLBACK).origin
  } catch {
    return new URL(FALLBACK).origin
  }
}

/** The public site's home page in the reader's language: `/es` or `/en`, never a hardcoded one. */
export function marketingHome(language: Language): string {
  return `${origin()}/${language}`
}
